import $dataStr from 'fxdom/es/dataStr.js';
import { html, strMap } from 'fxjs/es';
import {
  CategoryLevel1_CODE,
  CategoryLevel2_CODE,
} from '../../../../../../shared/mps-shared/domain/category/types.ts';
import { CategoryServiceS } from '../../../../../../shared/mps-shared/service/category-share.service.ts';
import { messages } from '../../../../../Creator/Setting/S/messages_id.js';
import { MShopStudioDigitalProductCreatorTmplS } from './module/MShopStudioDigitalProductCreatorTmplS.js';

/**
 *
 * @param cate_items
 * @param ebook_categories
 * @param store_ecommerce_info
 * @param products_memberships {object[] | null}
 * @return {*}
 */
export const categorySelectionPc = ({
  mps_category_infos,
  ebook_categories,
  store_ecommerce_info,
  products_memberships,
}) => {
  const mpsCategories = mps_category_infos.map(CategoryServiceS.createMpsCategoryAccessor);

  const eBookCategoryAccessor = CategoryServiceS.findCategoryByCode(mpsCategories, CategoryLevel1_CODE.EBOOK);
  const digitalCateItemAccessors = CategoryServiceS.findCategoryByCode(
    mpsCategories,
    CategoryLevel2_CODE.DIGITAL_GOODS,
  ).getChildren();

  return html`
    <div
      class="digital-product-category-selection"
      data-fx-json="${$dataStr({
        store_ecommerce_info,
        ebook_categories,
        products_memberships,
        mps_category_infos,
      })}"
    >
      <div class="digital-product-category-selection__title">
        <div class="digital-product-category-selection__title__main">${T(messages.digital_products.p3)}</div>
        <div class="digital-product-category-selection__title__sub">${T(messages.digital_products.p4)}</div>
      </div>
      <div class="digital-product-category-selection__categories">
        ${strMap(MShopStudioDigitalProductCreatorTmplS.makeCateMenuHtml, [
          eBookCategoryAccessor,
          ...digitalCateItemAccessors,
        ])}
      </div>
    </div>
  `;
};
